import { Address } from '@models/address';
import { MatterTitle } from '@models/matter';
import { Selector } from '@ngxs/store';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterTitlesState } from '@state/matter/titles/titles.state';

export interface FileComparisons {
	matterId: string;
	address: Address;
	closingDate: string;
	purchasePrice: number;
	legalDescription: string;
}

export class CloserSyncSyncMortgageFieldsSelectors {
	@Selector([
		SelectedMatter.id,
		SelectedMatter.address,
		SelectedMatter.closingDate,
		SelectedMatter.purchasePrice,
		MatterTitlesState.getPrimaryTitle,
	])
	static getFileComparisons(
		matterId: string,
		address: Address,
		closingDate: string,
		purchasePrice: number,
		primaryTitle: MatterTitle,
	): FileComparisons {
		const legalDescription = primaryTitle?.legalDescription;
		return {
			matterId,
			address,
			closingDate,
			purchasePrice,
			legalDescription,
		};
	}
}
